module.exports = __webpack_public_path__ + "img/BINDI 1 PURPLE.36fe2b4.svg";